<header></header>
<div class="post-login-1">
  <div class="post-login-1-col-1 h-100">
    <left-panel activeTab="5"></left-panel>
  </div>
  <div class="post-login-1-col-2">
    <div class="mt-30 pl-40 pr-40">
      <div class="color-base-1700 font-600 font-size-20px line-h-40">
        {{ "Settings" | translate }}
      </div>
      <div class="text-align-center">
        <grid-row class="justify-content-center">
          <grid-col col="3" mobile="12">
            <grid-row class="justify-content-center link">
              <grid-col col="auto">
                  <div class="profile-box-2" (click)="hiddenfileinput.click()">
                    <input type="file" (change)="fileChangeEvent($event)"
                    #hiddenfileinput>
                      <div class="profile-box-2-img change-profile">
                        <div *ngIf="this.url!==null">
                          <img [src]="this.url" alt="profilePicture"/>
                        </div>
                        <div *ngIf="this.url==null" class="color-base-1300 font-600 font-size-20px">
                          {{this.auth?.detailuser?.firstName.charAt(0).toLocaleUpperCase()+this.auth?.detailuser?.lastName.charAt(0).toLocaleUpperCase()}}
                        </div>
                          <div class="change-photo">
                            <ng-icon iconClass="icon-camera-profile" width="24" height="24"></ng-icon>
                              <div class="font-size-12 font-400 color-base-100 mt-10 w-100">
                                  {{"ChangeProfilePhoto" | translate}}
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="color-base-1300 font-600 font-size-20px line-h-28 mt-10">
                    {{this.auth?.detailuser?.firstName}} {{this.auth?.detailuser?.lastName}}
                  </div>  
                  <div class="color-base-500 font-400 font-size-12px line-h-18">
                    {{ "ClickProfilePhoto" | translate }}
                  </div>
              </grid-col>
          </grid-row>
          </grid-col>
        </grid-row>
      </div>
      <div class="pt-16 pb-16 pr-24 pl-24 bg-base-100 box-shadow br-16 mt-50 mb-30">
        <div class="pt-16 pb-16 border-bottom border-color-2100 link" (click)="settingsUpdateEmail()">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="11">
              <grid-row class="align-item-center col-space-min">
                <grid-col col="auto" >
                  <ng-icon iconClass="icon-email-green" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500 line-h-25">
                    {{ "EmailAddress" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                    <!-- m.rashid@email.com -->
                    {{this.auth?.detailuser?.emailId}} 
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
            </grid-col>
          </grid-row>
        </div>
        <div class="pt-16 pb-16 border-bottom border-color-2100 link" (click)="settingsUpdateMobileNumber()">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="11">
              <grid-row class="align-item-center col-space-min">
                <grid-col col="auto">
                  <ng-icon iconClass="icon-mobile-green" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500 line-h-25">
                    {{ "MobileNumber" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                    <!-- +973 333 9090 -->
                    {{"+973"}}
                    {{this.auth?.detailuser?.mobileNumber}} 
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
            </grid-col>
          </grid-row>
        </div>


        <!-- <div class="p-16 link" [routerLink]="['/ChangePin']">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="auto">
              <grid-row class="justify-content-center align-item-center col-space">
                <grid-col col="auto">
                  <ng-icon iconClass="icon-setting-change-pin" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500  line-h-25">
                    {{ "ChangePIN" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                    +973 333 9090
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
            </grid-col>
          </grid-row>
        </div> -->


        <!-- <div class="p-16 border-bottom border-color-2100 link" (click)="settingManageAddress()">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="auto">
              <grid-row class="justify-content-center align-item-center col-space">
                <grid-col col="auto">
                  <ng-icon iconClass="icon-loaction-green" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500  line-h-25">
                    {{ "ManageAddress" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                  +973 333 9090
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
            </grid-col>
          </grid-row>
        </div>
        <div class="p-16 border-bottom border-color-2100 link" (click)="settingPushNotifications()">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="auto">
              <grid-row class="justify-content-center align-item-center col-space">
                <grid-col col="auto">
                  <ng-icon iconClass="icon-bell-green" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500  line-h-25">
                    {{ "PushNotifications" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                +973 333 9090
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
            </grid-col>
          </grid-row>
        </div>
        <div class="p-16 border-bottom border-color-2100 link">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="auto">
              <grid-row class="justify-content-center align-item-center col-space">
                <grid-col col="auto">
                  <ng-icon iconClass="icon-manage-pin-green" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500  line-h-25">
                    {{ "ChangePIN" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                    +973 333 9090
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
            </grid-col>
          </grid-row>
        </div>
        <div class="p-16 link">
          <grid-row class="justify-content-between align-item-center">
            <grid-col col="auto">
              <grid-row class="justify-content-center align-item-center col-space">
                <grid-col col="auto">
                  <ng-icon iconClass="icon-fingerprint-green" width="24" height="24"></ng-icon>
                </grid-col>
                <grid-col col="auto">
                  <div class="font-600 font-size-16px color-base-1500  line-h-25">
                    {{ "BiometricLogin" | translate}}
                  </div>
                  <div class="font-400 font-size-14px color-base-500 line-h-20">
                    +973 333 9090
                  </div>
                </grid-col>
              </grid-row>
            </grid-col>
            <grid-col col="auto">
              <div class="form-group">
                <div class="custom-toggle">
                  <input type="checkbox" id="toggle1" class="not-on-this">
                  <label for="toggle1" class="not-on-this">
                    <span class="yes"> {{ "Yes" | translate }} </span>
                    <span class="no"> {{ "No" | translate }} </span>
                  </label>
                </div>
              </div>
            </grid-col>
          </grid-row>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <div class="post-login-1-col-3">
    <div class="pl-20 pr-20">
      <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
        {{"Sponsored" | translate }}
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img">
          <img src="~/../assets/images/sponsor-card-img.png" alt="">
        </div>
        <div class="content-box bg-2900">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedCashExtra" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"Applyourproduct" | translate }}
          </div>
        </div>
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img bg-2900">
          <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
        </div>
        <div class="content-box">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedMedicalInsurance" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"GetYourFamilyMedical" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>



<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Yes"
  [whiteButtonStatus]="true" whiteButtonText="No">
  <div class="text-align-center">
    <div class="mt-15 font-600 font-size-20px line-h-25 color-base-1300">
      {{ "Refreshtoken" | translate }}
    </div>
    <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
      {{ "Yoursessionisabout" | translate }}
    </div>
    <div class="font-600 font-size-26px color-base-1300">
      {{ "12:12" | translate }}
    </div>
  </div>
</modal>


<!-- Crop profile -->
<modal modalID="2" modalClass="height-auto-flex" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Save" [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="resizeAndUpload()" (whiteButton)="Close()">
  <div>

    <div class="svg-canvas">
      <!-- <svg width="400" height="400">
        <path d="M0,0H400 V400 H0z M100,150 A100,100 0 0 0 350,150M350,150 A100,100 0 0 0 100,150z" />
      </svg> -->
      <div class="img-circle"></div>
      <img id="avatarimage"  #avatarid alt="">
    </div>
      
      <div class="mt-30 custom-range-2">
          <ngx-slider [(value)]="value" [options]="options" (valueChange)="imageResize($event)" ></ngx-slider>
      </div>

      
  </div>
</modal>